module.exports = __webpack_public_path__ + "static/media/step1.ff6a6859.png";